<template>
  <div>
    <div class="flex justify-center mt-2">
      <div class="w-auto pb-1">
        <div class="bg-orange text-black p-1 hadow-md rounded">
          <span class="mr-1">Tu</span>
          <span
            class="mr-1"
            v-for="handTotal in playerCardTotal"
            :key="handTotal"
            >({{ handTotal }} )</span
          >
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-center gap-1">
      <Hand
        v-for="hand in playerHands"
        :key="hand.id"
        v-bind:hand="hand"
        v-bind:type="'player'"
        v-bind:showForPlayer="false"
        class="mx-2 my-2 flex flex-row"
      />
    </div>
  </div>
</template>

<script>
import store from "../store";
import Card from "./Card";
import Hand from "./Hand";

export default {
  name: "Player",
  components: {
    Card,
    Hand
  },
  store,

  computed: {
    playerHands() {
      return this.$store.getters.playerHands;
    },
    playerCardTotal() {
      return this.$store.getters.player.hands.map(elem => elem.cardTotal);
    },
    created() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Player.vue